export const NATIVE_PUSH_CHANNELS = {
  IOS: 'ios',
  ANDROID: 'android',
  ALL: 'all',
};

export const NATIVE_PUSH_GAME_ID = {
  SB: 'SB',
};

export const NATIVE_PUSH_TABS = {
  IOS: NATIVE_PUSH_CHANNELS.IOS,
  ANDROID: NATIVE_PUSH_CHANNELS.ANDROID,
};

export const MG_PUSH_MESSAGE_TYPE = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
};

export const NATIVE_PUSH_DEFAULT_ACTION = {
  NONE: '',
  URL: 'url',
  DEEPLINK: 'deeplink',
};
